import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalCommand.ConversationStream'

export default defineMessages({
  feedAriaLabel: {
    id: `${scope}.feedAriaLabel`,
    defaultMessage: 'Procurify AI conversation',
  },
  typing: {
    id: `${scope}.typing`,
    defaultMessage: 'Procurify AI is thinking',
  },
  thinkingDefault: {
    id: `${scope}.thinkingDefault`,
    defaultMessage: 'Thinking…',
  },
})
